import { Fragment } from 'react';
import { Link } from 'components/link';
import { EMPTY_CELL } from 'utils/empty-cell';
import type { AfeDetailEntity } from '../types';

const formatAfeType = (value: string | null | undefined) => {
  if (!value) return EMPTY_CELL;

  return value.replace(' & ', ' and ').replace(' (DC&E)', '');
};

/**
 * Canonical display label for an AFE: zero-padded id, e.g. "AFE-0365". Used
 * wherever an AFE must be named without relying on afe_number, which is often
 * null. Shared so the catalog detail header and the Expense Scenario fallback
 * summary cannot drift apart.
 * @param {string | number | null | undefined} value - The AFE id
 * @return {string} The display label
 */
const formatAfeLabel = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return 'AFE';

  const numericId =
    typeof value === 'number' ? value : Number.parseInt(String(value), 10);
  if (Number.isNaN(numericId)) return `AFE-${String(value)}`;

  return `AFE-${String(numericId).padStart(4, '0')}`;
};

const renderEntityLinks = (entities: AfeDetailEntity[]) => {
  if (entities.length === 0) return EMPTY_CELL;

  return entities.map((entity, index) => {
    const href = entity.href || `/entities/${entity.entityId}`;

    return (
      <Fragment key={entity.id}>
        {index > 0 ? ', ' : null}
        <Link to={href}>{entity.name}</Link>
      </Fragment>
    );
  });
};

export { formatAfeType, formatAfeLabel, renderEntityLinks };
